// extracted by mini-css-extract-plugin
export default {"inActive":"block-spend-file-generation_inActive__EiKif"};